import React, { ComponentType } from 'react'
import { ErrorBoundary } from 'react-error-boundary'
import { IntlProvider } from 'react-intl'

import { ErrorFallback } from 'components/shared'
import { ThemeConfigContextProvider } from 'context'
import { flatten } from 'flat'
import messages_pl from 'intl/pl'

function withTheme<T extends object>(WrappedComponent: ComponentType<T>) {
  return (props: T) => (
    <ErrorBoundary
      fallback={
        <IntlProvider locale="pl" messages={flatten(messages_pl)}>
          <ErrorFallback isPage />
        </IntlProvider>
      }
    >
      <ThemeConfigContextProvider>
        <WrappedComponent {...props} />
      </ThemeConfigContextProvider>
    </ErrorBoundary>
  )
}
export { withTheme }
